export default __webpack_public_path__ + "static/media/mixology-desktop-pattern@2x.31981043.png";